export enum ELang {
  EN = 'en-sg',
  ZH = 'zh-hk',
  TW = 'zh-tw',
  TH = 'th-th',
}

export enum ELanguage {
  EN = 'EN',
  ZH_HANT = 'ZH_HANT',
  TH = 'TH',
  TW = 'TW',
}

export const langMap = {
  [ELanguage.EN]: ELang.EN,
  [ELanguage.ZH_HANT]: ELang.ZH,
  [ELanguage.TH]: ELang.TH,
  [ELanguage.TW]: ELang.TW,
};
